import React from 'react'
import FilterListDataTable from './FilterListDataTable'
import SearchTrend from '../../Pages/Charts/dashboard/deals/SearchTrend';

/**
 * The TableComponent function returns a div element containing two child components,
 * FilterListDataTable and SearchTrend, wrapped in a flex container.
 * @returns The TableComponent is returning a JSX element.
 */
const TableComponent = () => {
  return (
    <div className='p-2 w-[100%] bg-[#EDEDED] border-t border-[#c3c3c3]'>
      <div className='w-full xl:flex xl:flex-nowrap gap-4'>
          <FilterListDataTable />
          <SearchTrend />
      </div>        
    </div>
  )
}

export default TableComponent